import classNames from 'classnames/bind';
import React from 'react';

import styles from './common.module.scss';

import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  return (
    <div className={cx('container')}>
      <label>
        Distance
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.distance.toFixed(1)} readOnly />
          <span className={cx('unit')}>m</span>
        </div>
      </label>
    </div>
  );
};

export default Item;
